// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// The data upload's name (AUT-6630 upload copy): the Data Sets control and this dialog's heading say the same words.
// The area has its own upload in Processing Area; this one takes the data.
export const DATA_UPLOAD_NAME = 'Upload Imagery and Point Clouds';

// An account that may upload .tif/.tiff only (editorFunctions without placeOrder) is told what it can upload.
export const IMAGERY_ONLY_UPLOAD_NAME = 'Upload Imagery';

export const dataUploadHeading = (acceptedExtensions?: string[]): string => (
  acceptedExtensions?.some((extension) => extension === '.las' || extension === '.laz')
    ? DATA_UPLOAD_NAME
    : IMAGERY_ONLY_UPLOAD_NAME
);
